module.exports = __webpack_public_path__ + "img/glass-group.c0cdedbb.png";